// exp_PORTFOLIO-61587_file
import { FC } from 'react';

import fakedoorModalImage from 'assets/fakedoor_modal_image.png';
import { push } from 'connected-react-router';
import { CAMPAIGN_CREATION_WIZARD_HISTORY_STATE } from 'utils/campaignCreationWizardFlow/campaignCreationWizardFlow';
import { CREATE_MENU_PAGE_ROUTE } from 'utils/constants/app';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import vacancyOfTheDayReturnButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vacancy_of_the_day/vacancy_of_the_day_return_button_click';
import vacancyOfTheDayUnavailableModalElementShown from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vacancy_of_the_day/vacancy_of_the_day_unavailable_modal_element_shown';
import {
    BottomSheet,
    BottomSheetWithImage,
    Button,
    Flex,
    ModalWithImage,
    NavBar,
    Text,
    Title,
    useBreakpoint,
} from '@hh.ru/magritte-ui';
import { CrossOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { useVacancyOfTheDayAnalyticsParams } from 'components/VacancyOfTheDayBuilder/useVacancyOfTheDayAnalyticsParams';

import { goToPromotionTypeStep } from 'store/models/campaignCreationWizard';
import { setMainMenuVacancy } from 'store/models/mainMenu';
import {
    selectVacancyOfTheDayModalVisible,
    selectVacancyOfTheDayVacancy,
    setVacancyOfTheDayModalVisible,
} from 'store/models/vacancyOfTheDay';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'VacancyOfTheDayPage.unavailable.title',
    subtitle: 'VacancyOfTheDayPage.unavailable.subtitle',
    button: 'VacancyOfTheDayPage.unavailable.button',
};

export const UnavailableModal: FC = () => {
    const visible = useSelector(selectVacancyOfTheDayModalVisible);
    const vacancy = useSelector(selectVacancyOfTheDayVacancy);

    const dispatch = useDispatch();
    const trls = useTrls();
    const { isMobile } = useBreakpoint();
    const { params } = useVacancyOfTheDayAnalyticsParams();

    const handleChooseOther = () => {
        vacancyOfTheDayReturnButtonClick(params);
        if (vacancy.vacancyId) {
            dispatch(
                setMainMenuVacancy({
                    vacancyId: vacancy.vacancyId,
                    vacancyName: vacancy.vacancyName ?? undefined,
                })
            );
            dispatch(
                goToPromotionTypeStep({
                    vacancyId: vacancy.vacancyId,
                    vacancyName: vacancy.vacancyName ?? undefined,
                })
            );
        }

        dispatch(push(CREATE_MENU_PAGE_ROUTE, CAMPAIGN_CREATION_WIZARD_HISTORY_STATE));
    };

    const handleClose = () => {
        dispatch(setVacancyOfTheDayModalVisible(false));
    };

    const header = !isMobile && (
        <NavBar>
            <NavBar.Actions right={<CrossOutlinedSize24 onClick={handleClose} />} />
        </NavBar>
    );

    const title = (
        <ElementShownAnchor fn={vacancyOfTheDayUnavailableModalElementShown} {...params}>
            <Title
                Element="h1"
                alignment="center"
                description={<Text typography="paragraph-2-regular">{trls(TrlKeys.subtitle)}</Text>}
                descriptionStyle="primary"
            >
                {<Text typography={isMobile ? 'title-5-semibold' : 'title-4-semibold'}>{trls(TrlKeys.title)}</Text>}
            </Title>
        </ElementShownAnchor>
    );

    const footer = (
        <Flex align="center" justify="center" p={isMobile ? 16 : 12} pt={isMobile ? 32 : 16}>
            <Button
                mode="primary"
                style="accent"
                stretched
                onClick={handleChooseOther}
                data-qa="vacancy-of-the-day-choose-other"
            >
                {trls(TrlKeys.button)}
            </Button>
        </Flex>
    );

    return (
        <>
            <ModalWithImage
                visible={visible}
                onClose={handleClose}
                size="small"
                header={header}
                image={
                    <NavBar.Trigger asChild endTrigger>
                        <ModalWithImage.Media backgroundUrl={fakedoorModalImage} />
                    </NavBar.Trigger>
                }
                title={title}
                footer={footer}
                data-qa="vacancy-of-the-day-unavailable-modal"
            />
            <BottomSheetWithImage
                visible={visible}
                onClose={handleClose}
                header={header}
                image={
                    <NavBar.Trigger asChild endTrigger>
                        <BottomSheet.Media backgroundUrl={fakedoorModalImage} />
                    </NavBar.Trigger>
                }
                title={title}
                footer={footer}
                data-qa="vacancy-of-the-day-unavailable-sheet"
            />
        </>
    );
};
